//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useDispatch, useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { Logo, Sample } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";
import CommonTitle from "../../../components/common/common.title";
import CommonProduct from "../../../components/common/common.product";
import ShopFilter from "./shop.filter";
import useWindowDimension from "../../../components/hook/use.window.dimension";
import Input from "../../../components/element/input";
import { useParams } from "react-router-dom";
import {
  getProductList,
  setFilteredProducts,
} from "../../../redux/reducer/product.reducer";
import { useEffect, useRef, useState } from "react";

export default function ShopProduct() {
  const dispatch = useDispatch();
  const { category } = useParams();
  const { width } = useWindowDimension();
  const { productList, productListLoading, filteredProducts } = useSelector(
    (state) => state.product
  );

  const [filterPrice, setFilterPrice] = useState([]);
  const [filterSearch, setFilterSearch] = useState("");
  const [filterAvailable, setFilterAvailable] = useState([]);
  // const [filteredProducts, setFilteredProducts] = useState([]);
  const [showMobileFilter, setShowMobileFilter] = useState(false);

  const getStockSummary = (products) => {
    let inStockCount = 0;
    let outOfStockCount = 0;

    const filterProducts =
      category === "all"
        ? products
        : products.filter(
            (product) =>
              product.category_model?.name?.toLowerCase() === category
          );

    filterProducts.forEach((product) => {
      if (product.quantity > 0) {
        inStockCount++;
      } else {
        outOfStockCount++;
      }
    });

    return { inStock: inStockCount, outOfStock: outOfStockCount };
  };

  const stockSummary = getStockSummary(productList);

  const filterProducts = () => {
    return (
      productList?.length > 0 &&
      productList.filter((product) => {
        const isInStock = product.quantity > 0;
        const isOutOfStock = product.quantity === 0;

        // Check availability filter
        const matchesAvailability =
          filterAvailable?.length > 0
            ? (filterAvailable.includes("in_stock") && isInStock) ||
              (filterAvailable.includes("out_stock") && isOutOfStock)
            : true;

        // Check price filter
        const fromPrice = filterPrice?.[0]?.from ?? 0;
        const toPrice = filterPrice?.[1]?.to ?? Infinity;
        const matchesPrice =
          filterPrice?.length > 0
            ? product.price >= fromPrice && product.price <= toPrice
            : true;

        // Check search filter
        const matchesSearch =
          filterSearch === "" ||
          product.name?.name
            ?.toLowerCase()
            .includes(filterSearch.toLowerCase());

        // Check category filter (assuming product.category is a string)
        const matchesCategory =
          category.toLowerCase() === "all" ||
          (product.category_model?.name &&
            product.category_model.name?.toLowerCase() ===
              category.toLowerCase());

        return (
          matchesAvailability &&
          matchesPrice &&
          matchesSearch &&
          matchesCategory
        );
      })
    );
  };

  const handleClearFilter = () => {
    setFilterPrice([]);
    setFilterSearch("");
    setFilterAvailable([]);

    if (showMobileFilter) {
      setShowMobileFilter(false);
    }
  };

  useEffect(() => {
    dispatch(getProductList())
      .unwrap()
      .then((res) => {
        dispatch(setFilteredProducts(res.data.all));
      });
  }, []);

  useEffect(() => {
    dispatch(setFilteredProducts(filterProducts()));
  }, [filterAvailable, filterPrice, filterSearch]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const shopFilterElement = document.getElementById("shop-filter");

      if (shopFilterElement && !shopFilterElement.contains(event.target)) {
        setShowMobileFilter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setShowMobileFilter]);

  return (
    <Container className="shop-product" id="product-list">
      <Row className="_row shop-search">
        <CommonTitle
          title={category || "Shop All"}
          subtitle={
            category !== "all" ? "Showing Products" : "Browse All In Once"
          }
          className="--shop"
        />
        <Row className="h-flex items-end gap-3">
          {width > 850 && (
            <Row className="_row search-frame">
              <Input
                value={filterSearch}
                className="_input search"
                placeholder="Search something.."
                onChange={(e) => setFilterSearch(e.target.value)}
              />
              <Icon icon="iconamoon:search" className="_svg search" />
            </Row>
          )}
          {width < 1120 && (
            <Col className="relative">
              <Row
                className="_row shop-sort pointer"
                onClick={() => setShowMobileFilter(true)}
              >
                <Icon className="_svg arrow" icon="iconamoon:arrow-down-2" />
                <h4 className="_label sort-title">Filter by</h4>
              </Row>
              <ShopFilter
                stockCount={stockSummary}
                filterPrice={filterPrice}
                filterSearch={filterSearch}
                filterAvailable={filterAvailable}
                filterProducts={filterProducts}
                // filteredProducts={filteredProducts}
                setFilterPrice={setFilterPrice}
                setFilterAvailable={setFilterAvailable}
                className={showMobileFilter ? "--expanded" : ""}
                handleClearFilter={handleClearFilter}
              />
            </Col>
          )}
        </Row>
      </Row>
      {width < 850 && (
        <Row className="_row search-frame">
          <Input
            value={filterSearch}
            className="_input search"
            placeholder="Search something.."
            onChange={(e) => setFilterSearch(e.target.value)}
          />
          <Icon icon="iconamoon:search" className="_svg search" />
        </Row>
      )}
      <Row className="_row shop-list">
        {width > 1120 && (
          <ShopFilter
            stockCount={stockSummary}
            filterPrice={filterPrice}
            filterSearch={filterSearch}
            filterAvailable={filterAvailable}
            filterProducts={filterProducts}
            // filteredProducts={filteredProducts}
            setFilterPrice={setFilterPrice}
            setFilterAvailable={setFilterAvailable}
            handleClearFilter={handleClearFilter}
          />
        )}
        <Row className="_row product-list">
          {productListLoading
            ? Array.from({ length: 4 }, (_, productLoadingIndex) => (
                <CommonProduct loading key={productLoadingIndex} />
              ))
            : filteredProducts?.length > 0 &&
              filteredProducts
                .filter(
                  (product) =>
                    category.toLowerCase() === "all" ||
                    product.category_model?.name?.toLowerCase() ===
                      category.toLowerCase()
                )
                .map((product, productIndex) => (
                  <CommonProduct product={product} key={productIndex} />
                ))}
        </Row>
      </Row>
    </Container>
  );
}
